import styles from './style.module.scss';

function Stars() {
  return (
    <>
      <div className={styles.stars} />
      <div className={styles.twinkl} />
    </>
  );
}

export default Stars;
